var map = {
	"./agent-automata-installation.json": 5800,
	"./agent_api.json": 7535,
	"./agent_database.json": 376,
	"./agent_os.json": 9775,
	"./agent_web_browser.json": 3210,
	"./backend_java_spring.json": 9250,
	"./frontend_nginx_react.json": 4976,
	"./orchestration.json": 7648
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3106;